import styles from './CourseProgressRing.module.css';

function CourseProgressRing({ percent, color, size = 52 }) {
  const r = (size - 6) / 2;
  const circ = 2 * Math.PI * r;
  const offset = circ - (percent / 100) * circ;
  return (
    <svg width={size} height={size} className={styles.ring}>
      <circle cx={size / 2} cy={size / 2} r={r} className={styles.ringTrack} strokeWidth="5" />
      <circle
        cx={size / 2} cy={size / 2} r={r}
        strokeWidth="5"
        fill="none"
        stroke={color}
        strokeDasharray={circ}
        strokeDashoffset={offset}
        strokeLinecap="round"
        style={{ transform: 'rotate(-90deg)', transformOrigin: '50% 50%', transition: 'stroke-dashoffset 0.6s ease' }}
      />
      <text x="50%" y="50%" textAnchor="middle" dominantBaseline="central" className={styles.ringText}>
        {percent}%
      </text>
    </svg>
  );
}

export default CourseProgressRing;